var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"text--bold",attrs:{"color":_vm.chipColor,"label":""}},[_vm._v(" "+_vm._s(_vm.$t("measures."+_vm.innerValue))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }